import {
  SCard,
  SCardIcon,
  SCardList,
  SDescriptionText,
  SImageArea,
  SSection,
  STextArea,
  STextAreaContent,
} from './LovedOnesSection.styled'
import { IconName } from 'components/icon'
import { ContentfulImage } from 'components/Image'
import { Spacer } from 'components/spacer/Spacer'
import { Text, Title, Title_h3_default } from 'components/Typography'
import { useTranslation } from 'next-i18next'
import Router from 'next/router'
import { mutateAnalyticsData } from 'utils/analytics'
import { useAuth } from 'utils/auth/hooks/useAuth'
import { useContentfulImages } from 'utils/contentful/ContentfulImagesContext'
import { numberRange } from 'utils/general'
import { NumberRange } from 'utils/types'

const cardIcons: Record<NumberRange<4>, IconName> = {
  '1': 'Goodtrust',
  '2': 'ColorFacebook',
  '3': 'ColorNetflix',
  '4': 'ColorGoogle',
}

export const LovedOnesSection = () => {
  const { t } = useTranslation('digital_executor')
  const images = useContentfulImages()

  const { isLogged } = useAuth()

  const onCardClick = async () => {
    if (isLogged) {
      await Router.push('/me/order')
    } else {
      mutateAnalyticsData({ button: 'wgs_card' })
      await Router.push('/wgs')
    }
  }
  return (
    <SSection>
      <SImageArea>
        <ContentfulImage {...images.digital_executor_section_loved_ones} />
      </SImageArea>
      <STextArea>
        <STextAreaContent>
          <Title variant={Title_h3_default} css={{ color: 'white' }}>
            {t('digital_executor.section_loved_ones.title')}
          </Title>

          <Spacer size={2} />

          <SDescriptionText>
            {t('digital_executor.section_loved_ones.description')}
          </SDescriptionText>

          <Spacer size={2} />

          <SCardList>
            {numberRange(4).map((i) => (
              <SCard key={i} onClick={onCardClick}>
                <SCardIcon name={cardIcons[i]} color="white" />
                <Text css={{ color: 'white', marginBottom: '0.75rem' }} variant={'bodyLargeBold'}>
                  {t(`digital_executor.section_loved_ones.card_${i}.title`)}
                </Text>

                <Text css={{ color: 'var(--c-gray400)' }}>
                  {t(`digital_executor.section_loved_ones.card_${i}.description`)}
                </Text>
              </SCard>
            ))}
          </SCardList>
        </STextAreaContent>
      </STextArea>
    </SSection>
  )
}
